import React from 'react'

import weightIcon from '../../../assets/weightIcon.png'
import valorIcon from '../../../assets/valorIcon.png'
import postalIcon from '../../../assets/postalIcon.png'
import providerIcon from '../../../assets/providerIcon.png'
import codIcon from '../../../assets/codIcon.png'
import clientIcon from '../../../assets/clientIcon.png'
import typeServiceIcon from '../../../assets/typeServiceIcon.png'
import worldIcon from '../../../assets/worldIcon.png'
import cityIcon from '../../../assets/cityIcon.png'
import provinceIcon from '../../../assets/provinceIcon.png'
import postalFileIcon from '../../../assets/postalIcon.png'
import ddpIcon from '../../../assets/ddpIcon.png'
import sizeIcon from '../../../assets/sizeIcon.png'

interface Props {
  valueKey: string
  alt?: string
  className?: string
}

import hsCodeIcon from '../../../assets/postalIcon.png'

const iconMap: Record<string, string> = {
  weight: weightIcon,
  declared_value: valorIcon,
  postal_code_range: postalIcon,
  distribution_provider: providerIcon,
  service_code: codIcon,
  service_types: typeServiceIcon,
  clients: clientIcon,
  states: worldIcon,
  town: cityIcon,
  township: provinceIcon,
  postal_code_list: postalFileIcon,
  hs_code: hsCodeIcon,
  ddu_ddp: ddpIcon,
  prc: ddpIcon,
  measurements: sizeIcon,
  country: worldIcon,
}

export const CriteriaIcon = ({ valueKey, alt = '', className = '' }: Props) => {
  const iconSrc = iconMap[valueKey]

  if (!iconSrc) return null

  return <img src={iconSrc} alt={alt || `${valueKey} icon`} className={className} />
}
